<template>
    <section class="course_sec"   v-if="listing!=null && listing.length">
        <div class="medical-training-center homepage_course_slider">
            <div class="container">
                <h3>Nama Medical Training Center</h3>
                <div class="row align-items-center medical_traning-block"  v-bind:class="{ disabled: isDisabledCourse(course.end_date) }"  v-for="course in listing" >
                    <div class="col-lg-2 col-md-4 col-5">
                        <div class="medical_left_image">
                            <img :src="hostname+'/admin/images/course_images/'+course.image">
                        </div>
                    </div>
                    <div class="col-lg-10 col-md-8 col-7">
                        <div class="medical_right_sec">
                            <h5>
                                {{ course.name_eng }}
                            </h5>
                            <span>
                                <i class="fas fa-calendar"></i>
                                {{  format_date(course.start_date,course.end_date) }}
                            </span>
                            <router-link class="read_more" v-bind:to="'/courses/'+course.slug+'/'">
                                Read More
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="medical_view_btn">
                    <router-link  v-bind:to="'/medical-training-center/'">
                        <span>
                            <i class="fas fa-circle"></i>
                            <i class="fas fa-circle"></i>
                            <i class="fas fa-circle"></i>
                        </span>
                        View More
                    </router-link>
                </div>
            </div>
        </div>
     </section>

</template>
<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
export default {
    name: 'PopularCourses',
    components: { Slick },

    data() {
        this.get_page_content();
        return {
            listing:null,
            hostname:this.$hostname,
            current_locale:this.$i18n_global.locale,
        };
    },
    methods:{
        async get_page_content() {
            var _self = this;
            await this.$axios_global.post(_self.$hostname+'/api/courses-by-category',{
                cat:'medical-education-clinical-reasearch',
                limit:4
            })
            .then((res) => {
                var response = res.data.data;
                // console.log(response,"courses-by-category")
                _self.listing = response;
            })
            .catch((error) => {
                return false;
            })
            return false;
        },
        isDisabledCourse(end_date){
            let A = this.$moment_global(end_date);
            let B = this.$moment_global();
            let diff = A.diff(B, 'days');// => 1
            return (diff < 0) ? true : false;
        },
        format_date(start,end){
            if (start && end) {
               var start_date_format =  this.$moment_global(String(start)).format('MMMM YYYY');
               var end_date_format   =  this.$moment_global(String(end)).format('MMMM YYYY');


               var start_year = this.$moment_global(String(start)).format('YYYY');
               var end_year = this.$moment_global(String(end)).format('YYYY');


                if(start_date_format == end_date_format){
                    var start_1 =  this.$moment_global(String(start)).format('Do');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return end_1;
                }
                else if(start_year == end_year){
                    var start_1 =  this.$moment_global(String(start)).format('Do MMMM');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return start_1 + ' - ' + end_1;
                }
                else{
                    var start_1 =  this.$moment_global(String(start)).format('Do MMMM YYYY');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return start_1 + ' - ' + end_1;
                }
            }
            return '';
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Home/NMTCCourses.vue